export const PXTestimonialsV2 = (function () {
	'use strict';

	let $testimonialCarousels;

	function init() {
		events();
	}

	function events() {
		$testimonialCarousels = $('.testimonials-v2-carousel');
		if (!$testimonialCarousels.length > 0) return null;

		$testimonialCarousels.each(function () {
			let $this = $(this);
			if (!$this.hasClass('slick-initialized')) {
				$this.slick({
					arrows: true,
					dots: true,
					customPaging: function (slider, i) {
						var thumb = $(slider.$slides[i]).data();
						return '<a>' + (i + 1) + '</a>';
					},
					infinite: false,
					speed: 300,
					slidesToShow: 1,
					// slidesToScroll: 3,
					swipeToSlide: true,
				});


				const nativeElement = $this.get(0); // Get the native DOM element
				const dots = nativeElement.querySelector('.slick-dots');
				if (dots) {
					const pButton = nativeElement.querySelector('.slick-prev');
					const nButton = nativeElement.querySelector('.slick-next');

					const navDiv = document.createElement('div');
					navDiv.className = `slick-nav`;

					if(pButton){
						navDiv.appendChild(pButton);
					}
					
					navDiv.appendChild(dots);
					if(nButton){
						navDiv.appendChild(nButton);
					}
					

					const slick = nativeElement;
					slick.appendChild(navDiv);

					const oldNavDiv = navDiv.previousElementSibling;
					if (oldNavDiv.classList.contains('slick-nav')) oldNavDiv.remove();
				}
			}


		});

	}

	return {
		init: init
	};
})();
